import styled from 'styled-components';
import {BRANDING_PAGE_WIDTH} from '../BrandingPage.css';

export const wrapper=styled.div`
    width: ${BRANDING_PAGE_WIDTH};
    max-width: 100%;
`;

export const top=styled.div`
    display: flex;
    height: 60px;
    justify-content: space-between;
    align-items: center;
    width: 95%;
`;

export const text=styled.div`
    font-size: 15px;
`;